import type { AuthConfig } from './types.ts'

/**
 * Fetch the runtime configuration document an SPA boots from, before it can
 * authenticate anything. The caller states the document's full shape — this only
 * guarantees the OAuth fields the provider reads.
 */
export const loadAuthConfig = async <TConfig extends AuthConfig>(
  configUrl: string
): Promise<TConfig> => {
  const response = await fetch(configUrl)
  if (!response.ok) {
    throw new Error(`configuration request failed (${response.status})`)
  }
  return (await response.json()) as TConfig
}
